import { Component, EventEmitter, HostBinding, Input, Output, } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
export class TooltipComponent {
    el;
    get tooltipId() {
        return this.id;
    }
    id;
    placement = 'top';
    tooltipMessage;
    templateRef;
    toggleOnClick = true;
    close;
    afterViewInit = new EventEmitter();
    constructor(el) {
        this.el = el;
    }
    ngAfterViewInit() {
        this.afterViewInit.emit();
    }
    get classes() {
        return `popover dpg-ui-tooltip ${this.placement}`;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TooltipComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: TooltipComponent, selector: "mhe-tooltip", inputs: { id: "id", placement: "placement", tooltipMessage: "tooltipMessage", templateRef: "templateRef", toggleOnClick: "toggleOnClick", close: "close" }, outputs: { afterViewInit: "afterViewInit" }, host: { properties: { "attr.id": "this.tooltipId" } }, ngImport: i0, template: "<div [attr.class]=\"classes\">\n  <div class=\"arrow\"></div>\n  <div class=\"tooltip-content\" role=\"tooltip\">\n    <ng-template #default let-options=\"options\">\n      <div class=\"popover-body\" cdkFocusInitial>\n        {{ tooltipMessage }}\n      </div>\n    </ng-template>\n\n    <ng-template\n      [ngTemplateOutlet]=\"templateRef || default\"\n      [ngTemplateOutletContext]=\"{ tooltipMessage: tooltipMessage }\"\n    >\n    </ng-template>\n  </div>\n</div>\n", styles: [":host{position:inherit}.popover{display:block;background-color:#fff;position:relative}\n"], directives: [{ type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TooltipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mhe-tooltip', template: "<div [attr.class]=\"classes\">\n  <div class=\"arrow\"></div>\n  <div class=\"tooltip-content\" role=\"tooltip\">\n    <ng-template #default let-options=\"options\">\n      <div class=\"popover-body\" cdkFocusInitial>\n        {{ tooltipMessage }}\n      </div>\n    </ng-template>\n\n    <ng-template\n      [ngTemplateOutlet]=\"templateRef || default\"\n      [ngTemplateOutletContext]=\"{ tooltipMessage: tooltipMessage }\"\n    >\n    </ng-template>\n  </div>\n</div>\n", styles: [":host{position:inherit}.popover{display:block;background-color:#fff;position:relative}/*# sourceMappingURL=tooltip.component.css.map */\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { tooltipId: [{
                type: HostBinding,
                args: ['attr.id']
            }], id: [{
                type: Input
            }], placement: [{
                type: Input
            }], tooltipMessage: [{
                type: Input
            }], templateRef: [{
                type: Input
            }], toggleOnClick: [{
                type: Input
            }], close: [{
                type: Input
            }], afterViewInit: [{
                type: Output
            }] } });
